import { render, staticRenderFns } from "./PayResult.vue?vue&type=template&id=c350d82c&scoped=true&"
import script from "./PayResult.vue?vue&type=script&lang=js&"
export * from "./PayResult.vue?vue&type=script&lang=js&"
import style0 from "./PayResult.vue?vue&type=style&index=0&id=c350d82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c350d82c",
  null
  
)

export default component.exports